import { createListModalComponent } from 'factories/ListModal'

export default createListModalComponent({
  getStorageKey: (self) => 'selectFilterTemplate',
  allowActionsMenu: (self) => false,
})()
